module.exports = __webpack_public_path__ + "static/media/hero-wordmark.a836f6d7.svg";